<template lang="pug">
y-dialog(v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
  v-card
    v-card-title.px-4.py-3
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          div.text-xl.font-bold.neutral700--text.text-center {{ $t('send_email') }}
        v-col(cols="1" align="right")
          v-btn.ml-n3(text icon @click="showModal = !showModal")
            v-icon(color="neutral700" :size="24") mdi-close
            
    v-divider
    v-card-text.pa-8
      div.text-lg.font-medium.neutral700--text {{ type == 'customers' ? $t('confirmation_send_email_customers') : $t('confirmation_send_email_donor') }}
      div.heading-6.basic700--text.mt-4 {{ $t('email_preview') }}
      v-card.message-preview-border.pa-4.mt-4.round-xl(outlined)
        div.text-md.font-normal(:class="subject ? 'basic700--text' : 'basic500--text'") {{ subject ? `${$t('subject')}:` : '' }} {{ subject || $t('send_email_placeholder_1') }}
        div.text-md.font-normal.mt-2(:class="content ? 'basic700--text' : 'basic500--text'" v-html="content || $t('send_email_placeholder_2')")
      div.text-md.font-normal.neutral700--text.mt-6 {{ $t('you_cant_undo_send_email') }}
      
    v-divider
    v-card-actions.pa-4
      v-spacer
      v-btn.text-none(color='white', text @click='showModal = false')
        .text-md.font-bold.primary400--text {{ $t('cancel') }}
      v-btn.button-md(color='textColorAccent' depressed dark :loading="isLoading" @click='clickSend')
        .text-md.font-bold.basic100--text {{ $t('send') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SendMessageDialog',
  props: ['open', 'eventName', 'subject', 'content', 'donors', 'group', 'type'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    clickSend () {
      this.isLoading = true
      let data = {
        name: this.eventName,
        subject: this.subject,
        content: this.content,
        method: 'email'
      }
      if (this.group) {
        data.group = this.group
      }
      if (this.donors && this.donors.length > 0) {
        data.customers = this.donors.map(m => m.id)
        delete data.group
      }
      this.$axios.post(`/connect/${this.company.slug}/blast_events`, data)
        .then(() => {
          this.$emit('redirect')
          this.showMessage(['success', 'Your email is being processed and is currently being sent. This process may take a few minutes, depending on the size and complexity of the email.'])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
</style>